@if (showMap) {
  <div class="mapContainer" [id]="mapContainerName"></div>
}

@if (!showMap) {
  <div class="placeHolder">
    <span [innerHtml]="'showmap_test_1' | translate"></span>
    <div class="switch-container-in" style="justify-content: center">
      <dx-switch [value]="showMap" (onValueChanged)="onSwitchChanged($event)"></dx-switch>
      <span class="switch-span-in"[innerHtml]="'switch_showmap_text_on' | translate"></span>
    </div>
  </div>
}

@if (showMap) {
  <div>
    <div class="switch-container-out">
      <dx-switch [value]="showMap" (onValueChanged)="onSwitchChanged($event)"></dx-switch>
      <span class="switch-span-out" [innerHtml]="'switch_showmap_text_off' | translate"></span>
    </div>
  </div>
}
